import checkPartner from './checkPartner';
import { mapGetters } from 'vuex';
import userBenefitCurrentMutation from '@/mixins/currentMutation/userBenefitCurrentMutation';
import lodash from 'lodash';

export default {
  mixins: [checkPartner, userBenefitCurrentMutation],
  computed: {
    ...mapGetters({
      userDeactivated: 'profile/dashboard/userDeactivated'
    }),
    showBenefits() {
      return (
        !this.isUaRu &&
        this.showInsuranceProviderBenefitBox &&
        (!this.currentProvider ||
          (this.currentProvider.additionalInfo.slug !== 'samoplatce' &&
            this.currentProvider.additionalInfo.type !== 'private'))
      );
    },
    questionsAvailable() {
      return this.$auth.user.services && this.$auth.user.services.question !== 'inactive';
    },
    questionFormRestricted() {
      return (
        this.$auth.user.services &&
        this.$auth.user.services.question === 'visible' &&
        this.$auth.user.services.questionMessage === 'service_not_supported_in_this_language'
      );
    },
    labOnlineAvailable() {
      return this.$auth?.user?.services?.['lab-online'] === 'active';
    },
    hasVideoCall() {
      const { videoCallAllowed } = this.currentMutation ?? {};
      const hasValidHost = this.$auth.user.invitation.host !== null;

      if (hasValidHost) {
        return videoCallAllowed === 'CoreAndFamily';
      }

      return videoCallAllowed?.includes('Core');
    },
    videoCallAvailable() {
      return (
        !this.isUaRu &&
        this.$auth.user?.benefit.active &&
        this.hasVideoCall &&
        this.currentMutation?.videoCallLink &&
        !this.userDeactivated
      );
    },
    videoTherapyAvailable() {
      if (
        this.$auth.user?.services?.videotherapy === 'inactive' ||
        !this.$auth.user?.benefit.active
      ) {
        return false;
      }

      if (
        this.currentMutation &&
        Object.hasOwn(this.currentMutation, 'videoCallTherapistAllowed')
      ) {
        const { videoCallTherapistAllowed } = this.currentMutation ?? {};
        const hasValidHost = this.$auth.user.invitation.host !== null;

        if (hasValidHost) {
          return videoCallTherapistAllowed === 'CoreAndFamily';
        }

        return videoCallTherapistAllowed.includes('Core');
      }

      return false;
    },
    orderAvailable() {
      return this.$auth.user.services && this.$auth.user.services.order !== 'inactive';
    },
    preventionAvailable() {
      return (
        !this.isUaRu &&
        this.$auth.user.services &&
        this.$auth.user.services.prevention !== 'inactive'
      );
    },
    thematicCounsellingAvailable() {
      return (
        this.$i18n.locale === 'cs' &&
        this.$auth.user.benefit &&
        !this.$auth.user.benefit.active &&
        !this.userDeactivated
      );
    },
    covidLineAvailable() {
      return this.$auth.user && this.$auth?.user?.benefit?.active && this.hasCovidLink;
    },
    assistLineAvailable() {
      return this.$auth.user && this.$auth?.user?.benefit?.active && this.hasAssistLink;
    },
    availableServiceCount() {
      return lodash.countBy([
        this.questionsAvailable,
        this.labOnlineAvailable,
        this.videoCallAvailable,
        this.orderAvailable,
        this.preventionAvailable,
        this.thematicCounsellingAvailable,
        this.assistLineAvailable
      ]).true;
    },
    showNewsletter() {
      return (
        ['sk', 'en', 'cs'].includes(this.$i18n.locale) &&
        this.$auth.user.newsletterAgreement !== undefined &&
        !this.$auth.user.newsletterAgreement
      );
    }
  }
};
